import { ProductInfoBlueStripeComponent } from './../components/product-info-blue-stripe/product-info-blue-stripe.component';
import { ProductListComponent } from './../components/product-list/product-list.component';
import { SolucaoRecomendadaComponent } from './../../views/leadership-result/solucao-recomendada/solucao-recomendada.component';
import { BookCarrouselComponent } from './../../views/leadership-result/carrousel/book-carrousel/book-carrousel.component';
import { ArticleCarrouselComponent } from './../../views/leadership-result/carrousel/article-carrousel/article-carrousel.component';
import { TestListComponent } from './../components/test-list/test-list.component';
import { PillarCardListComponent } from './../components/pillar-card-list/pillar-card-list.component';
import { CourseEventsListComponent } from './../components/course-events-list/course-events-list.component';
import { FilterComponent } from './../components/filter/filter.component';
import { RouterModule } from '@angular/router';
import { ArticleListComponent } from './../components/article-list/article-list.component';
import { ProductTypeOptionComponent } from './../components/product-type-option/product-type-option.component';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { VideoCarrouselComponent } from './../components/video-carrousel/video-carrousel.component';
import { BaseModule } from './base/base.module';
import { CadastreSeStripeComponent } from './../components/cadastre-se-stripe/cadastre-se-stripe.component';
import { PillarListComponent } from './../components/pillar-list/pillar-list.component';
import { NgModule } from '@angular/core';
import { PaginationComponent } from '../components/pagination/pagination.component';



//ng-module
@NgModule({
  declarations: [
    PillarListComponent,
    CadastreSeStripeComponent,
    VideoCarrouselComponent,
    ProductTypeOptionComponent,
    ArticleListComponent,
    FilterComponent,
    CourseEventsListComponent,
    PillarCardListComponent,
    TestListComponent,
    PaginationComponent,
    ArticleCarrouselComponent,
    BookCarrouselComponent,
    SolucaoRecomendadaComponent,
    ProductListComponent,
    ProductInfoBlueStripeComponent
  ],
  imports: [
    BaseModule,
    SwiperModule,
    RouterModule,
  ],
  exports: [
    PillarListComponent,
    CadastreSeStripeComponent,
    VideoCarrouselComponent,
    ProductTypeOptionComponent,
    ArticleListComponent,
    FilterComponent,
    CourseEventsListComponent,
    PillarCardListComponent,
    TestListComponent,
    PaginationComponent,
    ArticleCarrouselComponent,
    BookCarrouselComponent,
    SolucaoRecomendadaComponent,
    ProductListComponent,
    ProductInfoBlueStripeComponent
  ],
  providers: [],
  bootstrap: []
})
export class SharedComponentsModule { }